import { Icon, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { ChangePasswordDialog } from './change-password-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { ChangePasswordProps as Props } from './types';

export const ChangePassword = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ChangePassword', className)}
      sx={SX.root}
    >
      <Stack direction="row" justifyContent="space-between">
        <Stack gap={0.5}>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <Icon name="lock-outline" size={20} color="grey.600" />
            <Typography variant="body4" fontWeight={500} color="grey.600">
              Password
            </Typography>
          </Stack>
          <TextEllipsis variant="body3" fontWeight={500}>
            *****************
          </TextEllipsis>
        </Stack>
        <ChangePasswordDialog />
      </Stack>
    </Styled.Wrapper>
  );
});

ChangePassword.displayName = 'ChangePassword';
